var fe = Object.defineProperty;
var ge = (h, e, t) => e in h ? fe(h, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : h[e] = t;
var a = (h, e, t) => (ge(h, typeof e != "symbol" ? e + "" : e, t), t);
const ve = "prod", Y = "1.0.5", re = "YYEVA", d = new class {
  constructor() {
    a(this, "warn");
    a(this, "error");
    a(this, "debug");
    a(this, "info");
    a(this, "log");
    a(this, "op", { level: "debug", channel: "", showtips: !0 });
    a(this, "colors", { debug: "#3498db", info: "#16a085", warn: "#e67e22", error: "#e74c3c" });
    a(this, "levels", { debug: 1, info: 2, warn: 3, error: 4 });
  }
  logType(h) {
    const e = h.toLocaleUpperCase();
    let t = [];
    return this.op.showtips && (t = [`%c ${this.op.channel || re} %c ${e} `, "background:#2c3e50;color:#fff;padding: 1px;border-radius: 2px 0 0 2px;", `background:${this.colors[h]};color: #fff;padding: 1px; border-radius: 0 2px 2px 0;`]), t;
  }
  setup(h) {
    const { channel: e, level: t, showtips: i } = self.LoggerConfig || {};
    this.op = { ...this.op, ...h }, typeof i == "boolean" && (this.op.showtips = i);
    const s = t ? this.levels[t] : this.op.level ? this.levels[this.op.level] : 2, o = !e || e === this.op.channel, r = (...n) => {
    };
    this.error = s <= 4 && o ? console.error.bind(console, ...this.logType("error")) : r, this.warn = s <= 3 && o ? console.warn.bind(console, ...this.logType("warn")) : r, this.info = s <= 2 && o ? console.log.bind(console, ...this.logType("info")) : r, this.log = s <= 2 && o ? console.log.bind(console, ...this.logType("info")) : r, this.debug = s <= 1 && o ? console.log.bind(console, ...this.logType("debug")) : r;
  }
}(), I = navigator.userAgent.toLowerCase(), ye = I.indexOf("micromessenger") > -1, be = /baidu/.test(I), Q = /iphone|ipad|ipod/i.test(I), ae = /macintosh/i.test(I), xe = /^((?!chrome|android).)*safari/i.test(I), we = Q || ae;
I.indexOf("mqqbrowser");
const ee = /android|adr/i.test(I), Ce = I.indexOf("ucbrowser") > -1, Ee = I.indexOf("quark") > -1, Te = () => {
  const h = I.match(/chrome\/([\d\.]+)/);
  let e = h ? h[1] : "0.0.0";
  return e = e.split(".")[0], e = e ? Number(e) : 0, e;
}, T = { baidu: be, weixin: ye, apple: we, ios: Q, android: ee, uc: Ce, quark: Ee, mac: ae, safari: xe }, H = window;
H.yyeva_wx_is_ready = !!H.yyeva_wx_is_ready;
const Fe = new class {
  constructor() {
    a(this, "isReady", !1);
  }
  get ready() {
    return H.yyeva_wx_is_ready || this.isReady;
  }
  set ready(h) {
    H.yyeva_wx_is_ready = h, this.isReady = h;
  }
  initVideoIDPosition(h) {
    T.weixin && T.ios && document.addEventListener("WeixinJSBridgeReady", () => {
      this.ready = !0, h.map((e) => {
        const t = document.createElement("video");
        t.setAttribute("id", e), document.body.appendChild(t), t.style.visibility = "hidden";
      });
    });
  }
  wxReady() {
    return d.debug("[wxReady] resolve", this.ready), new Promise((h) => {
      if (!T.weixin || !T.ios)
        return void h(!0);
      if (this.ready)
        return h(!0), void d.debug("[wxReady] resolve", this.ready);
      const e = setInterval(() => {
        d.debug("[wxReady] setInterval", this.ready), this.ready === !0 && (clearInterval(e), h(!0));
      }, 300);
      document.addEventListener("WeixinJSBridgeReady", () => {
        d.debug("[wxReady] WeixinJSBridgeReady", this.ready), this.ready = !0, e && clearInterval(e), h(!0);
      });
    });
  }
}(), ne = (h) => h instanceof HTMLInputElement ? !1 : /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*?)\s*$/i.test(h);
function B() {
  return !(ee && Te() <= 70) && typeof OffscreenCanvas < "u" && self.OffscreenCanvas;
}
var L = ((h) => (h.NotAllowedError = "NotAllowedError", h))(L || {}), Z = ((h) => (h.canplaythrough = "canplaythrough", h.muted = "muted", h))(Z || {}), O = ((h) => (h.aspectFill = "aspectFill", h.aspectFit = "aspectFit", h.scaleFill = "scaleFill", h))(O || {});
class he {
  constructor(e) {
    a(this, "op");
    a(this, "fps", 30);
    a(this, "videoFps", 30);
    a(this, "config");
    a(this, "isUseMeta", !1);
    a(this, "hasAudio", !1);
    a(this, "ofs");
    a(this, "ctx");
    a(this, "effectTypes", { txt: ["txt", "text"], img: ["img", "image"] });
    a(this, "effectWidth", "effectWidth");
    a(this, "effectHeight", "effectHeight");
    a(this, "effectTag", "effectTag");
    a(this, "effectType", "effectType");
    a(this, "effectId", "effectId");
    a(this, "renderFrame", "renderFrame");
    a(this, "outputFrame", "outputFrame");
    a(this, "frameIndex", "frameIndex");
    a(this, "scaleMode", "scaleMode");
    a(this, "data", "data");
    this.op = e;
    const t = B() ? new OffscreenCanvas(300, 300) : document.createElement("canvas"), i = t.getContext("2d", { willReadFrequently: !0 });
    this.ctx = i, this.ofs = t, e.useMetaData && (this.isUseMeta = !0), e.dataUrl && (this.effectHeight = "h", this.effectWidth = "w", this.effectTag = "srcTag", this.effectType = "srcType", this.effectId = "srcId", this.renderFrame = "frame", this.outputFrame = "mFrame", this.frameIndex = "i", this.data = "obj");
  }
  destroy() {
    this.ofs && (this.ctx = null, this.ofs instanceof HTMLCanvasElement ? this.ofs.remove() : this.ofs = void 0), this.config = void 0;
  }
  setConfig(e) {
    this.config = e, e.descript.fps && (this.fps = e.descript.fps, this.videoFps = e.descript.fps), e.descript.hasAudio && (this.hasAudio = !0);
  }
  async setup() {
    if (this.op.dataUrl) {
      const { info: e, src: t, frame: i } = await this.getConfig(this.op.dataUrl);
      this.fps = e.fps || this.fps, e.fps && (this.videoFps = e.fps), this.config = { descript: { width: e.videoW, height: e.videoH, isEffect: e.isVapx, rgbFrame: e.rgbFrame, alphaFrame: e.aFrame, fps: e.fps, version: 0 }, effect: t, datas: i };
    }
    this.op.fps && (this.fps = this.op.fps), await this.parseFromSrcAndOptions();
  }
  get isUseBitmap() {
    return !!self.createImageBitmap && this.op.useBitmap;
  }
  dataURItoBlob(e) {
    const t = e.split(",")[0].split(":")[1].split(";")[0], i = self.atob(e.split(",")[1]), s = new ArrayBuffer(i.length), o = new Uint8Array(s);
    for (let r = 0; r < i.length; r++)
      o[r] = i.charCodeAt(r);
    return new Blob([o], { type: t });
  }
  createImageElement(e) {
    return new Promise((t, i) => {
      const s = new Image();
      s.crossOrigin = "anonymous", s.onload = function() {
        t(s);
      }, s.onerror = function(o) {
        d.error("frame load fail:" + e), i(void 0);
      }, s.src = e;
    });
  }
  async loadImg(e) {
    try {
      const t = ne(e);
      if (this.isUseBitmap) {
        let i;
        return i = t ? this.dataURItoBlob(e) : await fetch(e).then((s) => s.ok ? s.blob() : void d.error("fetch request failed, url: " + e)).catch((s) => {
          d.error("fetch, err=", s);
        }), i ? this.op.renderType === "canvas2d" ? self.createImageBitmap(i) : self.createImageBitmap(i, { imageOrientation: "flipY" }) : void 0;
      }
      return typeof e != "string" || e.indexOf("http") !== -1 || t || (e = `${location.protocol}//${location.host}${e}`), this.createImageElement(e);
    } catch (t) {
      return void d.warn("fetch, else err=", t);
    }
  }
  parseFromSrcAndOptions() {
    var t;
    if (!((t = this.config) != null && t.effect))
      return;
    const e = this.op.effects || {};
    return Promise.all(this.config.effect.map(async (i) => {
      const s = i[this.effectType], o = i[this.effectTag];
      if (this.effectTypes.txt.indexOf(s) > -1) {
        if (e[o]) {
          const r = { fontStyle: e.fontStyle, fontColor: e.fontColor, fontSize: e.fontSize };
          if (typeof e[o] == "string")
            i.text = e[o];
          else {
            i.text = e[o].text;
            const n = e[o];
            n.fontStyle && (r.fontStyle = n.fontStyle), n.fontColor && (r.fontColor = n.fontColor), n.fontSize && (r.fontSize = n.fontSize);
          }
          i.img = await this.makeTextImg(i, r, i.effectHeight);
        }
      } else
        this.effectTypes.img.indexOf(s) > -1 && (i.img = await this.makeImage(i, e[o]));
    }));
  }
  async makeImage(e, t) {
    if (!this.ctx)
      return;
    const i = this.ctx, s = Math.ceil(e[this.effectWidth]), o = Math.ceil(e[this.effectHeight]);
    let r = null;
    if (t && (r = await this.loadImg(t)), i.canvas.width = s, i.canvas.height = o, !e.scaleMode || !r)
      return r || (i.clearRect(0, 0, s, o), i.getImageData(0, 0, s, o));
    switch (e.scaleMode) {
      case O.aspectFill: {
        let n = 1;
        n = s / o > r.width / r.height ? s / r.width : o / r.height;
        const c = Math.round(r.width * n), l = Math.round(r.height * n), u = Math.round((s - c) / 2), p = Math.round((l - o) / 2);
        return i.save(), i.translate(0, l), i.scale(1, -1), i.drawImage(r, u, p, c, l), i.restore(), i.getImageData(0, 0, s, o);
      }
      case O.aspectFit: {
        let n = 1;
        n = s / o < r.width / r.height ? s / r.width : o / r.height;
        const c = Math.round(r.width * n), l = Math.round(r.height * n), u = Math.round((s - c) / 2), p = Math.round((l - o) / 2);
        return i.save(), i.translate(0, l), i.scale(1, -1), i.drawImage(r, u, p, c, l), i.restore(), i.getImageData(0, 0, s, o);
      }
      case O.scaleFill:
      default:
        return r;
    }
  }
  _getText(e, t, i) {
    var s, o;
    if (!((o = (s = this.op) == null ? void 0 : s.font) != null && o.overflow) || this.op.font.overflow === "cut") {
      const r = e.measureText(t).width;
      if (i == null)
        i = r;
      else if (r > i) {
        let n = t.length;
        for (; e.measureText(t + "...").width > i && n > 0; )
          n -= 1, t = t.substring(0, n);
        t += "...";
      }
    }
    return t;
  }
  defaultFontInfo(e, t) {
    if (ee) {
      let i = "sans-serif";
      const s = t.font.split(" ");
      return s && s.length && (i = s[s.length - 1]), ["normal", `${Math.round(e)}px`, i];
    }
    return Q ? ["normal", `${Math.round(e)}px`, "SFUI-Heavy"] : ["600", `${Math.round(e)}px`, "Microsoft YaHei"];
  }
  async makeTextImg(e, t = {}, i = 0) {
    if (!this.ctx)
      return;
    const s = this.ctx;
    t.fontStyle && (e.fontStyle = t.fontStyle), t.fontColor && (e.fontColor = t.fontColor), t.fontSize && (e.fontSize = t.fontSize);
    const { fontStyle: o, fontColor: r, fontSize: n } = e, c = Math.ceil(e[this.effectWidth]), l = Math.ceil(e[this.effectHeight]);
    s.canvas.width = c, s.canvas.height = l, s.textBaseline = "middle", s.textAlign = "center";
    const u = e.text || "", p = u.length, f = l - 2, g = (m) => {
      var F, x;
      m = m || f, (x = (F = this.op) == null ? void 0 : F.font) != null && x.overflow && this.op.font.overflow !== "cut" && m * p > c - 1 && (m = Math.min(c / p * 1, f));
      const C = this.defaultFontInfo(m, s);
      return o === "b" && C.unshift("bold"), C.join(" ");
    };
    if (o)
      typeof o == "string" ? (s.font = o, r && (s.fillStyle = r)) : typeof o == "object" ? (s.font = o.font || g(n), s.fillStyle = o.color || r) : typeof o == "function" && (s.font = g(n), r && (s.fillStyle = r), o(null, s, e));
    else {
      const m = g(n);
      s.font = m, r && (s.fillStyle = r);
    }
    d.info("getFontStyle, style: ", s.font, ", text:", u), s.clearRect(0, 0, s.canvas.width, s.canvas.height);
    const w = Math.floor(c / 2), v = Math.floor(l / 2);
    if (s.fillText(function(m, C, F) {
      const x = document.createElement("div");
      x.style.position = "absolute", x.style.visibility = "hidden", x.style.whiteSpace = "nowrap", x.style.left = "-9999px", x.style.font = C, x.innerText = m, document.body.appendChild(x);
      let _ = m, b = window.getComputedStyle(x).width;
      if (d.info("getTextByMaxWidth width=", b), parseInt(b, 10) > F) {
        let R = m.length;
        for (; _ = m.substring(0, R - 1) + "...", x.innerText = _, b = window.getComputedStyle(x).width, console.log("getTextByMaxWidth.. width=", b, _), !(parseInt(b, 10) <= F); )
          R -= 1;
      }
      return document.body.removeChild(x), _;
    }(u, s.font, c), w, v), B() && this.ofs instanceof OffscreenCanvas) {
      const m = await this.ofs.convertToBlob();
      return this.op.renderType === "canvas2d" ? self.createImageBitmap(m) : self.createImageBitmap(m, { imageOrientation: "flipY" });
    }
    return s.getImageData(0, 0, c, l);
  }
  getFrame(e) {
    return this.config.datas && this.config.datas.find((t) => t[this.frameIndex] === e);
  }
  getConfig(e) {
    return new Promise((t, i) => {
      const s = new XMLHttpRequest();
      s.open("GET", e, !0), s.responseType = "json", s.onload = function() {
        if (s.status === 200 || s.status === 304 && s.response) {
          const o = s.response;
          t(o);
        } else
          i(new Error("http response invalid" + s.status));
      }, s.send();
    });
  }
}
class _e {
  constructor(e) {
    a(this, "PER_SIZE", 9);
    a(this, "canvas");
    a(this, "ctx");
    a(this, "ofs");
    a(this, "version");
    a(this, "gl");
    a(this, "op");
    e.useOfsRender ? (this.canvas = document.createElement("canvas"), this.ctx = this.canvas.getContext("2d"), e.container.appendChild(this.canvas), e.resizeCanvas && this.setSizeCanvas(this.canvas, e.resizeCanvas), this.ofs = B() && self.createImageBitmap && e.useBitmap ? new OffscreenCanvas(300, 300) : document.createElement("canvas")) : (this.ofs = document.createElement("canvas"), e.resizeCanvas && this.setSizeCanvas(this.ofs, e.resizeCanvas), e.container.appendChild(this.ofs)), this.initGlContext(), this.op = e;
  }
  setSizeCanvas(e, t) {
    switch (t) {
      case "percent":
        e.style.width = "100%", e.style.height = "100%";
        break;
      case "percentH":
        e.style.height = "100%";
        break;
      case "percentW":
        e.style.width = "100%";
    }
  }
  initGlContext() {
    const e = this.ofs, t = { alpha: !0, antialias: !1, depth: !0, failIfMajorPerformanceCaveat: !1, premultipliedAlpha: !0, stencil: !1, preserveDrawingBuffer: !1 };
    this.gl = e.getContext("webgl2", t), this.version = 2, this.gl || (this.gl = e.getContext("webgl", t), this.version = 1, this.gl || (this.version = "canvas2d")), d.debug("[Webgl]initGlContext, version=", this.version);
  }
  destroy() {
    if (this.gl) {
      this.gl.clear(this.gl.COLOR_BUFFER_BIT);
      const e = this.gl.getExtension("WEBGL_lose_context");
      e && (e.loseContext(), d.debug("lose_context")), this.gl = null;
    }
    this.canvas && this.canvas.remove(), this.ofs instanceof HTMLCanvasElement ? (this.ofs.remove(), this.gl = null, d.debug("[destroy remove canvas]")) : this.ofs = void 0;
  }
  getVsSource() {
    return this.version === 2 ? this.getVs2() : this.getVs1();
  }
  getFsSource() {
    return this.version === 2 ? this.getFs2() : this.getFs1();
  }
  getVs2() {
    return `#version 300 es
    in vec2 a_position; // 接受顶点坐标
    in vec2 a_texCoord; // 接受纹理坐标
    in vec2 a_alpha_texCoord; // 接受纹理坐标
    out vec2 v_alpha_texCoord; // 接受纹理坐标
    out vec2 v_texcoord; // 传递纹理坐标给片元着色器
    uniform vec2 u_scale;
    void main(void) {
      gl_Position = vec4(u_scale * a_position, 0.0, 1.0); // 设置坐标
      v_texcoord = a_texCoord; // 设置纹理坐标
      v_alpha_texCoord = a_alpha_texCoord; // 设置纹理坐标
    }
    `;
  }
  getVs1() {
    return `attribute vec2 a_position; // 接受顶点坐标
    attribute vec2 a_texCoord; // 接受纹理坐标
    attribute vec2 a_alpha_texCoord; // 接受纹理坐标
    varying vec2 v_alpha_texCoord; // 接受纹理坐标
    varying vec2 v_texcoord; // 传递纹理坐标给片元着色器
    uniform vec2 u_scale;
    void main(void){
       gl_Position = vec4(u_scale * a_position, 0.0, 1.0); // 设置坐标
       v_texcoord = a_texCoord; // 设置纹理坐标
       v_alpha_texCoord = a_alpha_texCoord; // 设置纹理坐标
    }`;
  }
  getFs2() {
    if (!this.gl)
      return "";
    const e = this.gl, t = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS) - 1;
    let i = "", s = "";
    if (t > 0 && (this.op.dataUrl || this.op.useMetaData)) {
      const o = [], r = [];
      for (let n = 0; n < t; n++)
        o.push(`if(ndx == ${n + 1}){
                          color = texture(u_image${n + 1},uv);
                      }`), r.push(`uniform sampler2D u_image${n + 1};`);
      s = `
              ${r.join(`
`)}
              uniform float image_pos[${t * this.PER_SIZE}];
              vec4 getSampleFromArray(int ndx, vec2 uv) {
                  vec4 color;
                  ${o.join(" else ")}
                  return color;
              }
              `, i = `
              vec4 srcColor,maskColor;
              vec2 srcTexcoord,maskTexcoord;
              int srcIndex;
              float x1,x2,y1,y2,mx1,mx2,my1,my2; //显示的区域

              for(int i=0;i<${t * this.PER_SIZE};i+= ${this.PER_SIZE}){
                  if ((int(image_pos[i]) > 0)) {
                    srcIndex = int(image_pos[i]);

                      x1 = image_pos[i+1];
                      x2 = image_pos[i+2];
                      y1 = image_pos[i+3];
                      y2 = image_pos[i+4];

                      mx1 = image_pos[i+5];
                      mx2 = image_pos[i+6];
                      my1 = image_pos[i+7];
                      my2 = image_pos[i+8];


                      if (v_texcoord.s>x1 && v_texcoord.s<x2 && v_texcoord.t>y1 && v_texcoord.t<y2) {
                          srcTexcoord = vec2((v_texcoord.s-x1)/(x2-x1),(v_texcoord.t-y1)/(y2-y1));
                           maskTexcoord = vec2(mx1+srcTexcoord.s*(mx2-mx1),my1+srcTexcoord.t*(my2-my1));
                           srcColor = getSampleFromArray(srcIndex,srcTexcoord);
                           maskColor = texture(u_image_video, maskTexcoord);
                           srcColor.a = srcColor.a*(maskColor.r);

                           bgColor = vec4(srcColor.rgb*srcColor.a,srcColor.a) + (1.0-srcColor.a)*bgColor;

                      }
                  }
              }
              `;
    }
    return `#version 300 es
      precision lowp float;
      in vec2 v_texcoord;
      in vec2 v_alpha_texCoord;
      out vec4 fragColor;
      uniform sampler2D u_image_video;
      ${s}

      void main(void) {
          vec4 bgColor = vec4(texture(u_image_video, v_texcoord).rgb, texture(u_image_video,v_alpha_texCoord).r);
          ${i}
          fragColor = bgColor;
      }
      `;
  }
  getFs1() {
    if (!this.gl)
      return "";
    const e = this.gl, t = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS) - 1;
    let i = "", s = "";
    if (t > 0) {
      const o = [], r = [];
      for (let n = 0; n < t; n++)
        o.push(`if(ndx == ${n + 1}){
                          color = texture2D(u_image${n + 1},uv);
                      }`), r.push(`uniform sampler2D u_image${n + 1};`);
      s = `
              ${r.join(`
`)}
              uniform float image_pos[${t * this.PER_SIZE}];
              vec4 getSampleFromArray(int ndx, vec2 uv) {
                  vec4 color;
                  ${o.join(" else ")}
                  return color;
              }
              `, i = `
              vec4 srcColor,maskColor;
              vec2 srcTexcoord,maskTexcoord;
              int srcIndex;
              float x1,x2,y1,y2,mx1,mx2,my1,my2; //显示的区域

              for(int i=0;i<${t * this.PER_SIZE};i+= ${this.PER_SIZE}){
                  if ((int(image_pos[i]) > 0)) {
                    srcIndex = int(image_pos[i]);

                      x1 = image_pos[i+1];
                      x2 = image_pos[i+2];
                      y1 = image_pos[i+3];
                      y2 = image_pos[i+4];

                      mx1 = image_pos[i+5];
                      mx2 = image_pos[i+6];
                      my1 = image_pos[i+7];
                      my2 = image_pos[i+8];


                      if (v_texcoord.s>x1 && v_texcoord.s<x2 && v_texcoord.t>y1 && v_texcoord.t<y2) {
                          srcTexcoord = vec2((v_texcoord.s-x1)/(x2-x1),(v_texcoord.t-y1)/(y2-y1));
                           maskTexcoord = vec2(mx1+srcTexcoord.s*(mx2-mx1),my1+srcTexcoord.t*(my2-my1));
                           srcColor = getSampleFromArray(srcIndex,srcTexcoord);
                           maskColor = texture2D(u_image_video, maskTexcoord);
                           srcColor.a = srcColor.a*(maskColor.r);

                           bgColor = vec4(srcColor.rgb*srcColor.a,srcColor.a) + (1.0-srcColor.a)*bgColor;

                      }
                  }
              }
              `;
    }
    return `
      precision lowp float;
      varying vec2 v_texcoord;
      varying vec2 v_alpha_texCoord;
      uniform sampler2D u_image_video;
      ${s}

      void main(void) {
          vec4 bgColor = vec4(texture2D(u_image_video, v_texcoord).rgb, texture2D(u_image_video,v_alpha_texCoord).r);
          ${i}
          // bgColor = texture2D(u_image[0], v_texcoord);
          gl_FragColor = bgColor;
      }
      `;
  }
}
const y = class y {
  constructor(e) {
    a(this, "storeName");
    a(this, "op");
    a(this, "frameCacheCount", 5);
    a(this, "requestAnimationFramePercent", 0.95);
    a(this, "hasRequestAnimationFrame", !1);
    a(this, "animationType");
    a(this, "fps", 0);
    a(this, "videoDurationTime", 0);
    e.videoSource && e.useFrameCache && (this.op = e, this.storeName = function(t) {
      const { effects: i, mode: s, container: o } = t;
      let r = ne(t.videoSource) ? t.videoSource.substring(22, 88) : t.videoSource;
      if (i) {
        const n = Object.keys(i).map((c) => c + "=" + i[c]).join("&");
        r += n.indexOf("?") > -1 ? "&" : "?", r += n;
      }
      return o && o.clientHeight && (r += `${r.indexOf("?") > -1 ? "&" : "?"}mode=${s}&height=${o.clientHeight}&width=${o.clientWidth}`), r = r.replace(/\s+/g, ""), r;
    }(e), y.caches[this.storeName] || (d.debug("[mCache]", "[实例化]"), y.caches[this.storeName] = {}, y.cacheKeys.push(this.storeName)), typeof e.useFrameCache == "number" && e.useFrameCache > 0 && (this.frameCacheCount = e.useFrameCache), d.debug("[mcache]", "[constructor]", "设置缓存数", this.frameCacheCount, "缓存视频", y.cacheKeys), d.debug("[mcache]", this.storeName, `当前缓存帧数 ${Object.keys(y.caches[this.storeName] || {}).length}`));
  }
  setOptions({ fps: e, animationType: t, videoDurationTime: i }) {
    this.fps = e, this.animationType = t, this.videoDurationTime = i, d.debug("[mcache]", { fps: e, animationType: t, videoDurationTime: i });
  }
  async setup() {
    this.setAnimationStatus();
  }
  setAnimationStatus() {
    this.animationType !== "requestVideoFrameCallback" && Object.keys(y.caches[this.storeName] || {}).length > 0 && (this.hasRequestAnimationFrame = !0), d.debug("[mCache]", "[setAnimationStatus]", "hasRequestAnimationFrame", this.hasRequestAnimationFrame);
  }
  isCache() {
    return Object.keys(y.caches[this.storeName]).length > 0;
  }
  get() {
    return y.caches[this.storeName];
  }
  set(e) {
    y.caches[this.storeName] = e;
  }
  getFrame(e) {
    return this.hasRequestAnimationFrame ? y.caches[this.storeName] && y.caches[this.storeName][e] ? y.caches[this.storeName][e] : "skip" : y.caches[this.storeName] ? y.caches[this.storeName][e] : void 0;
  }
  setFrame(e, t) {
    !t || y.caches[this.storeName][e] || this.hasRequestAnimationFrame || (y.caches[this.storeName][e] = t);
  }
  checkCache() {
    if (this.animationType !== "requestVideoFrameCallback") {
      const e = this.videoDurationTime * this.fps;
      let t = e * this.requestAnimationFramePercent;
      t = Math.round(t);
      const i = y.caches[this.storeName] || {};
      d.debug("[mCache]", "[checkCache] 当前缓存帧数", Object.keys(i).length, "需要缓存帧数", t, "缓存总数", e), i && Object.keys(i).length < t && (this.removeCacheItem(this.storeName), d.debug("[mCache]", "[checkCache] removeCacheItem", this.storeName));
    }
  }
  removeCache() {
    if (y.cacheKeys.length > this.frameCacheCount) {
      const e = y.cacheKeys.length - this.frameCacheCount;
      for (let t = 1; t < e; t++) {
        const i = y.cacheKeys.shift();
        this.removeCacheItem(i), d.debug("[mCache]", "[removeCache]", "达到视频缓存总数删除", i);
      }
    }
  }
  removeCacheItem(e) {
    y.caches[e] && (delete y.caches[e], y.caches[e] = {});
    const t = y.cacheKeys.indexOf(e);
    t > -1 && y.cacheKeys.splice(t, 1);
  }
  videoSeekedEvent() {
    this.checkCache(), this.setAnimationStatus();
  }
  destroy() {
    d.debug("[mCache]", "[destroy]"), this.removeCache(), this.checkCache();
  }
};
a(y, "caches", {}), a(y, "cacheKeys", []), a(y, "cachesOfs", {});
let J = y;
class de {
  constructor(e, t) {
    a(this, "canvas");
    a(this, "op");
    a(this, "mCache");
    this.canvas = e, this.op = t, this.mCache = new J(this.op);
  }
  isCache() {
    return this.mCache.isCache();
  }
  setCache(e) {
    this.op.useFrameCache && this.createFramesCache(e);
  }
  getCache(e) {
    if (this.op.useFrameCache)
      return this.mCache.getFrame(e);
  }
  destroy() {
    this.mCache.destroy();
  }
  async setup() {
    this.op.useFrameCache && await this.mCache.setup();
  }
  async createFramesCache(e) {
    if (this.canvas) {
      if (this.op.useBitmap && self.createImageBitmap)
        self.createImageBitmap(this.canvas).then((t) => {
          this.mCache.setFrame(e, t);
        });
      else if ("toDataURL" in this.canvas) {
        const t = this.canvas.toDataURL(), i = new Image();
        i.src = t, this.mCache.setFrame(e, i);
      }
    }
  }
}
class Ie {
  constructor(e) {
    a(this, "video");
    a(this, "program");
    a(this, "isPlay", !1);
    a(this, "op");
    a(this, "videoEntity");
    a(this, "webgl");
    a(this, "renderCache");
    a(this, "textureMap", {});
    a(this, "imagePos");
    a(this, "currentFrame", -1);
    d.debug("[Render In Webgl]"), this.op = e, this.webgl = new _e(e), this.webgl.ofs.addEventListener("webglcontextlost", (t) => {
      d.debug("[webglcontextlost]", t), t.preventDefault(), this.program = void 0;
    }), this.webgl.ofs.addEventListener("webglcontextrestored", () => {
      d.debug("[webglcontextrestored]"), this.webgl.initGlContext(), this.initWebgl();
    }), this.renderCache = new de(this.webgl.ofs, this.op), this.videoEntity = new he(e);
  }
  videoSeekedEvent() {
    return this.renderCache.mCache.videoSeekedEvent();
  }
  async setup(e) {
    if (!e)
      throw new Error("video must support!");
    await this.renderCache.setup(), await this.videoEntity.setup(), this.video = e, this.resizeCanvasToDisplaySize(), this.initWebgl();
  }
  resizeCanvasToDisplaySize() {
    var i;
    const e = (i = this.videoEntity.config) == null ? void 0 : i.descript, t = this.webgl.ofs;
    if (e) {
      const [s, o, r, n] = e.rgbFrame;
      t.width = r, t.height = n;
    } else {
      if (!this.video)
        return;
      const s = this.video.videoWidth ? this.video.videoWidth / 2 : 900, o = this.video.videoHeight ? this.video.videoHeight : 1e3;
      d.debug("[resizeCanvasToDisplaySize]", s, o), t.width = s, t.height = o;
    }
    this.op.useOfsRender && (this.webgl.canvas.width = t.width, this.webgl.canvas.height = t.height);
  }
  destroy() {
    this.webgl.destroy(), this.videoEntity.destroy(), this.renderCache.destroy();
  }
  render(e = 0) {
    var s;
    if (!(this.isPlay && this.webgl.gl && this.video && this.program && this.currentFrame !== e))
      return;
    this.currentFrame = e;
    const t = this.webgl.gl;
    if (this.op.useFrameCache) {
      const { width: o, height: r } = this.webgl.canvas, n = this.renderCache.getCache(e);
      if (n === "skip")
        return;
      if (n)
        return this.webgl.ctx.clearRect(0, 0, o, r), void this.webgl.ctx.drawImage(n, 0, 0, o, r, 0, 0, o, r);
    }
    const i = (s = this.videoEntity.config) == null ? void 0 : s.descript;
    if (i) {
      const o = this.videoEntity.getFrame(e), r = o ? o[this.videoEntity.data] : void 0;
      let n = [];
      const { width: c, height: l } = i;
      r && r.forEach((p) => {
        n[n.length] = +this.textureMap[p[this.videoEntity.effectId]];
        const [f, g] = i.rgbFrame, [w, v, m, C] = p[this.videoEntity.renderFrame], [F, x, _, b] = p[this.videoEntity.outputFrame], R = this.computeCoord(w + f, v + g, m, C, c, l), A = this.computeCoord(F, x, _, b, c, l);
        n = n.concat(R).concat(A);
      });
      const u = (t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS) - 1) * this.webgl.PER_SIZE;
      n = n.concat(new Array(u - n.length).fill(0)), this.imagePos = this.imagePos || t.getUniformLocation(this.program, "image_pos"), t.uniform1fv(this.imagePos, new Float32Array(n));
    }
    if (t.texImage2D(t.TEXTURE_2D, 0, t.RGB, t.RGB, t.UNSIGNED_BYTE, this.video), t.drawArrays(t.TRIANGLE_STRIP, 0, 4), this.op.useOfsRender) {
      const { width: o, height: r } = this.webgl.canvas;
      this.webgl.ctx.clearRect(0, 0, o, r), this.webgl.ctx.drawImage(t.canvas, 0, 0, o, r, 0, 0, o, r);
    }
    this.op.useFrameCache && this.renderCache.setCache(e);
  }
  getScale() {
    let e = 1, t = 1;
    if (this.video && this.op.mode) {
      const i = this.webgl.canvas ? this.webgl.canvas : this.webgl.ofs, s = i.clientWidth / i.clientHeight, o = i.width / i.height;
      switch (i.setAttribute("class", `e-video-${this.op.mode.toLocaleLowerCase()}`), this.op.mode) {
        case "AspectFill":
        case "vertical":
          t = 1, e = o / s;
          break;
        case "AspectFit":
        case "horizontal":
          e = 1, t = s / o;
          break;
        case "contain":
          t = 1, e = o / s, e > 1 && (t = 1 / e, e = 1);
          break;
        case "Fill":
        case "cover":
          t = 1, e = o / s, e < 1 && (t = 1 / e, e = 1);
      }
    }
    return [e, t];
  }
  initWebgl() {
    if (!this.webgl.gl)
      return;
    const e = this.webgl.gl;
    e.viewport(0, 0, e.drawingBufferWidth, e.drawingBufferHeight), e.disable(e.BLEND), e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, !0), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0);
    const t = this.createProgram(e);
    if (!t)
      return;
    this.program = t, this.initTexture(e, t), this.initVideoTexture(e, t);
    const i = e.getUniformLocation(t, "u_scale"), s = this.getScale();
    e.uniform2fv(i, new Float32Array(s));
  }
  initTexture(e, t) {
    var r;
    let i = 1;
    const s = (r = this.videoEntity.config) == null ? void 0 : r.effect;
    if (s) {
      for (const c in s) {
        const l = s[c];
        l.img && this.createTexture(e, i, l.img);
        const u = e.getUniformLocation(t, `u_image${i}`);
        e.uniform1i(u, i), this.textureMap[l[this.videoEntity.effectId]] = i++;
      }
      const n = e.createTexture();
      e.activeTexture(e.TEXTURE0), e.bindTexture(e.TEXTURE_2D, n), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, null);
    }
    this.createTexture(e, i);
    const o = e.getUniformLocation(t, "u_image_video");
    e.uniform1i(o, i);
  }
  getRgbaPos() {
    var t;
    const e = (t = this.videoEntity.config) == null ? void 0 : t.descript;
    if (e) {
      const { width: i, height: s } = e, [o, r, n, c] = e.rgbFrame, [l, u, p, f] = e.alphaFrame;
      return { rgbX: o, rgbY: r, rgbW: n, rgbH: c, vW: i, vH: s, aX: l, aY: u, aW: p, aH: f };
    }
    if (this.video) {
      const i = this.video.videoWidth ? this.video.videoWidth : 1800, s = this.video.videoHeight ? this.video.videoHeight : 1e3, o = i / 2, [r, n, c, l] = this.op.alphaDirection === "right" ? [0, 0, o, s] : [o, 0, o, s], [u, p, f, g] = this.op.alphaDirection === "right" ? [o, 0, o, s] : [0, 0, o, s];
      return { rgbX: r, rgbY: n, rgbW: c, rgbH: l, vW: i, vH: s, aX: u, aY: p, aW: f, aH: g };
    }
  }
  initVideoTexture(e, t) {
    const i = [], s = this.getRgbaPos();
    if (!s)
      return;
    const { rgbX: o, rgbY: r, rgbW: n, rgbH: c, vW: l, vH: u, aX: p, aY: f, aW: g, aH: w } = s, v = this.computeCoord(o, r, n, c, l, u), m = this.computeCoord(p, f, g, w, l, u);
    i.push(-1, 1, v[0], v[3], m[0], m[3]), i.push(1, 1, v[1], v[3], m[1], m[3]), i.push(-1, -1, v[0], v[2], m[0], m[2]), i.push(1, -1, v[1], v[2], m[1], m[2]);
    const C = new Float32Array(i);
    e.bindBuffer(e.ARRAY_BUFFER, e.createBuffer()), e.bufferData(e.ARRAY_BUFFER, C, e.STATIC_DRAW);
    const F = e.getAttribLocation(t, "a_position");
    e.enableVertexAttribArray(F);
    const x = e.getAttribLocation(t, "a_texCoord");
    e.enableVertexAttribArray(x);
    const _ = e.getAttribLocation(t, "a_alpha_texCoord");
    e.enableVertexAttribArray(_);
    const b = C.BYTES_PER_ELEMENT;
    e.vertexAttribPointer(F, 2, e.FLOAT, !1, 6 * b, 0), e.vertexAttribPointer(x, 2, e.FLOAT, !1, 6 * b, 2 * b), e.vertexAttribPointer(_, 2, e.FLOAT, !1, 6 * b, 4 * b);
  }
  createProgram(e) {
    const t = this.webgl.getVsSource(), i = this.webgl.getFsSource(), s = this.createShader(e, e.VERTEX_SHADER, t), o = this.createShader(e, e.FRAGMENT_SHADER, i), r = e.createProgram();
    if (r && s && o) {
      if (e.attachShader(r, s), e.attachShader(r, o), e.linkProgram(r), !e.getProgramParameter(r, e.LINK_STATUS)) {
        const n = e.getProgramInfoLog(r);
        d.error(n);
      }
      return e.useProgram(r), r;
    }
  }
  createShader(e, t, i) {
    const s = e.createShader(t);
    if (s)
      return e.shaderSource(s, i), e.compileShader(s), e.getShaderParameter(s, e.COMPILE_STATUS) || d.error(e.getShaderInfoLog(s)), s;
  }
  computeCoord(e, t, i, s, o, r) {
    return [e / o, (e + i) / o, (r - t - s) / r, (r - t) / r];
  }
  createTexture(e, t, i) {
    const s = e.createTexture(), o = e.TEXTURE0 + t;
    return d.debug("[createTexture]", o, t, "[ImageBitmap]Object"), e.activeTexture(o), e.bindTexture(e.TEXTURE_2D, s), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), i && e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, i), s;
  }
}
class Re {
  createCanvas() {
    return B() && self.createImageBitmap ? new OffscreenCanvas(300, 300) : document.createElement("canvas");
  }
  removeCanvas(e) {
    e instanceof HTMLCanvasElement ? e.remove() : e = void 0;
  }
  get2dContext(e) {
    return e.getContext("2d", { willReadFrequently: !0 });
  }
}
class ie extends Re {
  constructor(t) {
    super();
    a(this, "isPlay", !1);
    a(this, "webgl", { version: "canvas2d" });
    a(this, "videoEntity");
    a(this, "renderCache");
    a(this, "video");
    a(this, "ofs");
    a(this, "ctx");
    a(this, "canvas");
    a(this, "context");
    a(this, "op");
    a(this, "alphaCanvas");
    a(this, "alphaCtx");
    a(this, "canvasKey");
    a(this, "ctxKey");
    a(this, "drawEffect");
    d.debug("[Render In Canvas]"), this.op = t, this.ofs = this.createCanvas(), this.ctx = this.get2dContext(this.ofs), this.renderCache = new de(this.ofs, this.op), this.videoEntity = new he(t), this.alphaCanvas = this.createCanvas(), this.alphaCtx = this.get2dContext(this.alphaCanvas), this.drawEffect = {}, this.canvasKey = this.createCanvas(), this.ctxKey = this.get2dContext(this.canvasKey);
  }
  setSizeCanvas(t, i) {
    switch (i) {
      case "percent":
        t.style.width = "100%", t.style.height = "100%";
        break;
      case "percentH":
        t.style.height = "100%";
        break;
      case "percentW":
        t.style.width = "100%";
    }
  }
  getScale() {
    let [t, i, s, o, r, n, c, l] = [];
    const u = this.canvas, p = u.width, f = u.height;
    u.clientWidth, u.clientHeight;
    const g = u.clientWidth / u.clientHeight;
    return u.width, u.height, r = 0, n = 0, c = p, l = f, t = 0, i = 0, s = p, o = f, this.op.mode && (s = f * g, o = f, t = (p - s) / 2, i = 0), [t, i, s, o, r, n, c, l];
  }
  videoSeekedEvent() {
    return d.debug("[canvas2d][videoSeekedEvent]"), this.renderCache.mCache.videoSeekedEvent();
  }
  async setup(t) {
    var r, n, c, l;
    if (!t)
      throw new Error("video must support!");
    await this.renderCache.setup(), this.video = t, this.op.fps || (this.op.fps = 10), await this.videoEntity.setup();
    const i = document.createElement("canvas");
    this.op.container.appendChild(i), i.width = t.videoWidth / 2, i.height = t.videoHeight, this.context = i.getContext("2d"), this.canvas = i, this.ofs.width = t.videoWidth, this.ofs.height = t.videoHeight, this.canvasKey.width = i.width, this.canvasKey.height = i.height;
    const s = (n = (r = this.videoEntity) == null ? void 0 : r.config) == null ? void 0 : n.descript, o = (l = (c = this.videoEntity) == null ? void 0 : c.config) == null ? void 0 : l.effect;
    if (s) {
      const [u, p, f, g] = s.rgbFrame;
      i.width = f, i.height = g, this.ofs.width = s.width, this.ofs.height = s.height;
    }
    if (o)
      for (const u in o) {
        const p = o[u];
        p.img && (this.drawEffect[p.effectId] = p);
      }
    this.setSizeCanvas(i, this.op.resizeCanvas);
  }
  destroy() {
    this.clear(), this.videoEntity.destroy(), this.canvas && (this.canvas.remove(), delete this.canvas, this.canvas = null), this.removeCanvas(this.ofs), this.removeCanvas(this.alphaCanvas), this.removeCanvas(this.canvasKey), this.drawEffect = void 0;
  }
  clear() {
    var t, i;
    this.video !== void 0 && this.context && this.context.clearRect(0, 0, (t = this.video) == null ? void 0 : t.videoWidth, (i = this.video) == null ? void 0 : i.videoHeight);
  }
  render(t = 0) {
    var f, g;
    this.canvas;
    const [i, s, o, r, n, c, l, u] = this.getScale();
    ((g = (f = this.videoEntity) == null ? void 0 : f.config) == null ? void 0 : g.descript) ? this.renderMix(t) : this.renderLR(t), this.context.clearRect(n, c, l, u), this.context.drawImage(this.ofs, i, s, o, r, n, c, l, u);
  }
  drawWithCache(t) {
    if (this.op.useFrameCache) {
      const [i, s, o, r, n, c, l, u] = this.getScale(), p = this.renderCache.getCache(t);
      if (console.log("[canvas2d frameItem]", t, p), p && p !== "skip")
        return this.context.clearRect(n, c, l, u), this.context.drawImage(p, i, s, o, r, n, c, l, u), !0;
    }
  }
  saveFrameCache(t) {
    this.op.useFrameCache && this.renderCache.setCache(t);
  }
  renderKey(t = 0) {
    const i = this.videoEntity.getFrame(t), s = i ? i[this.videoEntity.data] : void 0;
    s && s.forEach((o) => {
      const [r, n, c, l] = o[this.videoEntity.renderFrame], [u, p, f, g] = o[this.videoEntity.outputFrame], w = o[this.videoEntity.effectId], v = this.drawEffect[w] || {};
      if (v.img && c > 0 && l > 0 && g > 0 && f > 0) {
        this.ctxKey.clearRect(0, 0, c, l), this.ctxKey.drawImage(v.img, 0, 0, c, l);
        const m = this.ctx.getImageData(u, p, f, g);
        let C = this.ctxKey.getImageData(0, 0, c, l);
        C = this.mixImageData(C, m, c / f), this.ctxKey.clearRect(0, 0, c, l), this.ctxKey.putImageData(C, 0, 0), this.ctx.drawImage(this.canvasKey, 0, 0, c, l, r, n, c, l);
      }
    });
  }
  renderMix(t = 0) {
    var m;
    const i = (m = this.videoEntity.config) == null ? void 0 : m.descript;
    if (!this.ctx || !this.isPlay || this.video === void 0 || !i)
      return;
    const [s, o, r, n] = i.rgbFrame, [c, l, u, p] = i.alphaFrame;
    this.ctx.clearRect(c, l, r, n);
    const f = this.video.videoWidth, g = this.video.videoHeight;
    this.ctx.drawImage(this.video, 0, 0, f, g, 0, 0, f, g);
    let w = this.ctx.getImageData(s, o, r, n);
    const v = this.ctx.getImageData(c, l, u, p);
    w = this.mixImageData(w, v, r / u), this.ctx.clearRect(0, 0, r, n), this.ctx.putImageData(w, 0, 0, 0, 0, r, n), this.renderKey(t);
  }
  mixImageData(t, i, s = 1) {
    s !== 1 && (i = this.scaleImageData(i, s));
    const o = Math.min(t == null ? void 0 : t.data.length, i == null ? void 0 : i.data.length);
    for (let r = 3; r < o; r += 4)
      t.data[r] = i.data[r - 1];
    return t;
  }
  scaleImageData(t, i) {
    const s = this.alphaCtx, o = Math.floor(t.width * i), r = Math.floor(t.height * i), n = s.createImageData(o, r), c = t.width, l = t.height;
    for (let u = 0; u < l; u++)
      for (let p = 0; p < c; p++) {
        const f = [t.data[4 * (u * t.width + p) + 0], t.data[4 * (u * t.width + p) + 1], t.data[4 * (u * t.width + p) + 2], t.data[4 * (u * t.width + p) + 3]];
        for (let g = 0; g < i; g++) {
          const w = Math.floor(u * i) + g;
          for (let v = 0; v < i; v++) {
            const m = Math.floor(p * i) + v;
            for (let C = 0; C < 4; C++)
              n.data[4 * (w * o + m) + C] = f[C];
          }
        }
      }
    return n;
  }
  renderLR(t = 0) {
    if (!this.ctx || !this.isPlay || this.video === void 0)
      return;
    const i = this.video.videoWidth, s = this.video.videoHeight, o = i / 2, r = s;
    if (this.ctx.drawImage(this.video, 0, 0, i, s, 0, 0, i, s), this.op.alphaDirection === "left") {
      const n = this.ctx.getImageData(o, 0, o, r), c = this.ctx.getImageData(0, 0, o, r);
      for (let l = 3, u = n == null ? void 0 : n.data.length; l < u; l += 4)
        n.data[l] = c.data[l - 1];
      this.ctx.putImageData(n, 0, 0, 0, 0, o, r);
    } else {
      const n = this.ctx.getImageData(o, 0, o, r), c = this.ctx.getImageData(0, 0, o, r);
      for (let l = 3, u = c == null ? void 0 : c.data.length; l < u; l += 4)
        c.data[l] = n.data[l - 1];
      this.ctx.putImageData(c, 0, 0, 0, 0, o, r);
    }
  }
}
const se = ["playing", "pause", "ended", "progress", "loadstart", "stop", "loadeddata", "loadedmetadata", "ratechange", "abort", "emptied", "error", "mozaudioavailable", "stalled", "suspend", "play", "waiting", "canplay", "canplaythrough", "seeked", "seeking"];
class Se {
  constructor(e, t) {
    a(this, "animateId");
    a(this, "animationType");
    a(this, "video");
    a(this, "fps", 20);
    a(this, "videoFps", 0);
    a(this, "frameDelay", 0);
    a(this, "frameStartTime", 0);
    a(this, "op");
    a(this, "isPlay");
    a(this, "requestAnim");
    a(this, "cancelAnim");
    a(this, "onUpdate");
    a(this, "currentTimeMillsecond", () => typeof performance > "u" ? (/* @__PURE__ */ new Date()).getTime() : performance.now());
    a(this, "drawFrame", (e = this.currentTimeMillsecond(), t) => {
      if (!this.isPlay)
        return;
      this.cancelAnim(), this.animateId = this.requestAnim(this.drawFrame);
      const i = (t == null ? void 0 : t.mediaTime) || this.video.currentTime, s = this.getCurrentFrame(i);
      this.onUpdate && this.onUpdate(s);
    });
    this.video = e, this.op = t, this.isPlay = !1, "requestVideoFrameCallback" in HTMLVideoElement.prototype && this.op.useAccurate ? this.animationType = "requestVideoFrameCallback" : typeof requestAnimationFrame < "u" ? this.animationType = "requestAnimationFrame" : this.animationType = "setTimeout", this.requestAnim = this.returnRequestAnim(), this.cancelAnim = this.returnCancelAnim();
  }
  setVideoFps({ videoFps: e, fps: t }) {
    this.fps = t, this.videoFps = e, this.animationType !== "requestVideoFrameCallback" && this.fps > 20 && (this.fps = 20);
  }
  async setup() {
    this.frameDelay = 1e3 / this.fps;
  }
  start() {
    this.frameDelay === 0 && this.fps > 0 && (this.frameDelay = 1e3 / this.fps), d.debug("animator start", this.animateId, this.frameDelay, this.fps), this.frameStartTime = this.currentTimeMillsecond(), this.cancelAnim(), this.animateId = this.requestAnim(this.drawFrame);
  }
  stop() {
    d.debug("animator stop", this.animateId), this.cancelAnim();
  }
  destroy() {
    d.debug("[animator destroy]", this.animateId), this.cancelAnim(), this.op = void 0, this.video = void 0, this.cancelAnim = void 0, this.requestAnim = void 0, this.onUpdate = void 0, this.drawFrame = void 0;
  }
  getCurrentFrame(e = 0) {
    return Math.round(e * this.videoFps) + (this.op.offset || 0);
  }
  returnRequestAnim() {
    switch (this.animationType) {
      case "requestVideoFrameCallback":
        return (e) => this.animateId = this.video.requestVideoFrameCallback(e);
      case "requestAnimationFrame":
        return (e) => requestAnimationFrame(() => {
          const t = this.currentTimeMillsecond(), i = t - this.frameStartTime;
          if (i > this.frameDelay)
            return this.frameStartTime = t - i % this.frameDelay, e();
          this.requestAnim && (this.animateId && this.cancelAnim(), this.animateId = this.requestAnim(e));
        });
      default:
        return (e) => this.animateId = window.setTimeout(e, 1e3 / this.fps);
    }
  }
  returnCancelAnim() {
    switch (this.animationType) {
      case "requestVideoFrameCallback":
        return () => this.animateId && this.video.cancelVideoFrameCallback(this.animateId);
      case "requestAnimationFrame":
        return () => this.animateId && cancelAnimationFrame(this.animateId);
      default:
        return () => this.animateId && clearTimeout(this.animateId);
    }
  }
}
const G = Object.freeze({ UNCOMPRESSED: 0, FIXED: 1, DYNAMIC: 2 }), ce = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], le = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258], ue = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577], pe = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], Ae = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
function V(h) {
  const e = Object.keys(h);
  let t = 0, i = 0, s = Number.MAX_SAFE_INTEGER;
  e.forEach((c) => {
    t = Number(c), i < t && (i = t), s > t && (s = t);
  });
  let o, r = 0;
  const n = {};
  for (let c = s; c <= i; c++) {
    o = h[c], o === void 0 && (o = []), o.sort((u, p) => u < p ? -1 : u > p ? 1 : 0);
    const l = {};
    o.forEach((u) => {
      l[r] = u, r++;
    }), n[c] = l, r <<= 1;
  }
  return n;
}
class oe {
  constructor(e, t = 0) {
    this.nowBitsLength = 0, this.isEnd = !1, this.buffer = e, this.bufferIndex = t, this.nowBits = e[t], this.nowBitsLength = 8;
  }
  read() {
    if (this.isEnd)
      throw new Error("Lack of data length");
    const e = 1 & this.nowBits;
    return this.nowBitsLength > 1 ? (this.nowBitsLength--, this.nowBits >>= 1) : (this.bufferIndex++, this.bufferIndex < this.buffer.length ? (this.nowBits = this.buffer[this.bufferIndex], this.nowBitsLength = 8) : (this.nowBitsLength = 0, this.isEnd = !0)), e;
  }
  readRange(e) {
    for (; this.nowBitsLength <= e; )
      this.nowBits |= this.buffer[++this.bufferIndex] << this.nowBitsLength, this.nowBitsLength += 8;
    const t = this.nowBits & (1 << e) - 1;
    return this.nowBits >>>= e, this.nowBitsLength -= e, t;
  }
  readRangeCoded(e) {
    let t = 0;
    for (let i = 0; i < e; i++)
      t <<= 1, t |= this.read();
    return t;
  }
}
class Pe {
  constructor(e) {
    this.index = 0, this.buffer = new Uint8Array(e), this.length = e, this._extendedSize = e;
  }
  write(e) {
    if (this.length <= this.index) {
      this.length += this._extendedSize;
      const t = new Uint8Array(this.length), i = this.buffer.length;
      for (let s = 0; s < i; s++)
        t[s] = this.buffer[s];
      this.buffer = t;
    }
    this.buffer[this.index] = e, this.index++;
  }
}
const De = V(function() {
  const h = { 7: [], 8: [], 9: [] };
  for (let e = 0; e <= 287; e++)
    e <= 143 ? h[8].push(e) : e <= 255 ? h[9].push(e) : e <= 279 ? h[7].push(e) : h[8].push(e);
  return h;
}());
function Le(h, e) {
  h.nowBitsLength < 8 && h.readRange(h.nowBitsLength);
  const t = h.readRange(8) | h.readRange(8) << 8;
  if (t + (h.readRange(8) | h.readRange(8) << 8) !== 65535)
    throw new Error("Data is corrupted");
  for (let i = 0; i < t; i++)
    e.write(h.readRange(8));
}
function Be(h, e) {
  const t = De, i = Object.keys(t);
  let s = 0, o = 0, r = Number.MAX_SAFE_INTEGER;
  i.forEach((m) => {
    s = Number(m), o < s && (o = s), r > s && (r = s);
  });
  let n, c, l, u, p, f, g, w, v = 0;
  for (; !h.isEnd; ) {
    for (n = void 0, s = r, v = h.readRangeCoded(r); n = t[s][v], n === void 0; ) {
      if (o <= s)
        throw new Error("Data is corrupted");
      s++, v <<= 1, v |= h.read();
    }
    if (n < 256)
      e.write(n);
    else {
      if (n === 256)
        break;
      c = n - 257, l = le[c], u = ce[c], 0 < u && (l += h.readRange(u)), p = h.readRangeCoded(5), f = ue[p], g = pe[p], 0 < g && (f += h.readRange(g)), w = e.index - f;
      for (let m = 0; m < l; m++)
        e.write(e.buffer[w + m]);
    }
  }
}
function ke(h, e) {
  const t = h.readRange(5) + 257, i = h.readRange(5) + 1, s = h.readRange(4) + 4;
  let o = 0;
  const r = {};
  for (let E = 0; E < s; E++)
    o = h.readRange(3), o !== 0 && (r[o] || (r[o] = []), r[o].push(Ae[E]));
  const n = V(r), c = Object.keys(n);
  let l = 0, u = Number.MAX_SAFE_INTEGER;
  c.forEach((E) => {
    o = Number(E), l < o && (l = o), u > o && (u = o);
  });
  const p = {}, f = {};
  let g, w = 0, v = 0, m = 0;
  const C = t + i;
  for (let E = 0; E < C; ) {
    for (g = void 0, o = u, w = h.readRangeCoded(u); g = n[o][w], g === void 0; ) {
      if (l <= o)
        throw new Error("Data is corrupted");
      o++, w <<= 1, w |= h.read();
    }
    if (g === 16 ? v = 3 + h.readRange(2) : g === 17 ? (v = 3 + h.readRange(3), m = 0) : g === 18 ? (v = 11 + h.readRange(7), m = 0) : (v = 1, m = g), m <= 0)
      E += v;
    else
      for (; v; )
        E < t ? (p[m] || (p[m] = []), p[m].push(E++)) : (f[m] || (f[m] = []), f[m].push(E++ - t)), v--;
  }
  const F = V(p), x = V(f), _ = Object.keys(F);
  let b = 0, R = 0, A = Number.MAX_SAFE_INTEGER;
  _.forEach((E) => {
    b = Number(E), R < b && (R = b), A > b && (A = b);
  });
  const me = Object.keys(x);
  let P = 0, $ = 0, k = Number.MAX_SAFE_INTEGER;
  me.forEach((E) => {
    P = Number(E), $ < P && ($ = P), k > P && (k = P);
  });
  let S, W, q, j, D, z, X, U, M, te, N = 0;
  for (; !h.isEnd; ) {
    for (S = void 0, b = A, N = h.readRangeCoded(A); S = F[b][N], S === void 0; ) {
      if (R <= b)
        throw new Error("Data is corrupted");
      b++, N <<= 1, N |= h.read();
    }
    if (S < 256)
      e.write(S);
    else {
      if (S === 256)
        break;
      for (W = S - 257, q = le[W], j = ce[W], 0 < j && (q += h.readRange(j)), D = void 0, U = k, M = h.readRangeCoded(k); D = x[U][M], D === void 0; ) {
        if ($ <= U)
          throw new Error("Data is corrupted");
        U++, M <<= 1, M |= h.read();
      }
      z = ue[D], X = pe[D], 0 < X && (z += h.readRange(X)), te = e.index - z;
      for (let E = 0; E < q; E++)
        e.write(e.buffer[te + E]);
    }
  }
}
/**
 * @license Copyright (c) 2018 zprodev
 */
function Ue(h) {
  const e = new oe(h);
  if (e.readRange(4) !== 8)
    throw new Error("Not compressed by deflate");
  return e.readRange(4), e.readRange(5), e.readRange(1), e.readRange(2), function(t, i = 0) {
    const s = new Pe(10 * t.length), o = new oe(t, i);
    let r = 0, n = 0;
    for (; r !== 1; ) {
      if (r = o.readRange(1), n = o.readRange(2), n === G.UNCOMPRESSED)
        Le(o, s);
      else if (n === G.FIXED)
        Be(o, s);
      else {
        if (n !== G.DYNAMIC)
          throw new Error("Not supported BTYPE : " + n);
        ke(o, s);
      }
      if (r === 0 && o.isEnd)
        throw new Error("Data length is insufficient");
    }
    return s.buffer.subarray(0, s.index);
  }(h, 2);
}
const Me = new RegExp("yyeffectmp4json\\[\\[(.*?)\\]\\]yyeffectmp4json"), Ne = new class {
  constructor() {
    a(this, "exp");
    this.exp = new RegExp("eJzt3U1v20gMgOH", "g");
  }
  getdata(h) {
    try {
      const e = h.match(Me);
      if (!e)
        return;
      const t = e[1], i = this.inflate(t);
      let s = this.unit8Tostring(i);
      return s = JSON.parse(s), d.debug("[ParserGetData]", s), s;
    } catch (e) {
      return void d.warn(e);
    }
  }
  base64ToArrayBuffer(h) {
    const e = window.atob(h), t = e.length, i = new Uint8Array(t);
    for (let s = 0; s < t; s++)
      i[s] = e.charCodeAt(s);
    return i.buffer;
  }
  unit8Tostring(h) {
    return new TextDecoder().decode(h);
  }
  inflate(h) {
    return Ue(new Uint8Array(this.base64ToArrayBuffer(h)));
  }
}();
class Oe {
  constructor({ name: e, version: t, storeName: i } = { name: "e-video", version: 1, storeName: "video" }) {
    a(this, "storeName");
    a(this, "dbPromise");
    d.debug("[DBCache] DB", e, t, i), this.storeName = i, this.dbPromise = new Promise((s, o) => {
      if (self.indexedDB !== void 0) {
        const r = self.indexedDB.open(e, t);
        r.onerror = (n) => (d.warn(`IndexedDB open fail, ${n.type}`), s(void 0)), r.onsuccess = () => s(r.result), r.onupgradeneeded = (n) => {
          const c = r.result;
          n.oldVersion && n.oldVersion < n.newVersion && (d.debug("[DB] deleteObjectStore"), c.deleteObjectStore(i)), c.createObjectStore(i);
        };
      } else
        o("IndexedDB not supported");
    });
  }
  async find(e) {
    return await this.dbPromise.then(async (t) => await new Promise((i, s) => {
      const o = t.transaction([this.storeName], "readonly").objectStore(this.storeName).get(e);
      o.onsuccess = () => {
        i(o.result);
      }, o.onerror = () => s(new Error("Find Error"));
    }));
  }
  async insert(e, t) {
    return await this.dbPromise.then(async (i) => await new Promise((s, o) => {
      const r = i.transaction([this.storeName], "readwrite"), n = r.objectStore(this.storeName).put(t, e);
      r.oncomplete = () => s(), n.onerror = () => o(new Error("Insert Error"));
    }));
  }
  async delete(e) {
    return await this.dbPromise.then(async (t) => await new Promise((i, s) => {
      const o = t.transaction([this.storeName], "readwrite").objectStore(this.storeName).delete(e);
      o.onsuccess = () => i(), o.onerror = () => s(new Error("Delete Error"));
    }));
  }
}
const K = new class {
  constructor() {
    a(this, "useIndexDB", !0);
    a(this, "db");
  }
  set IndexDB(h) {
    this.useIndexDB = h, d.debug("[DBCache] IndexDB", this.useIndexDB);
  }
  model() {
    return typeof window < "u" && this.useIndexDB ? (this.db || (d.debug("[DBCache] new DB"), this.db = new Oe()), this.db) : this;
  }
  async find(h) {
  }
  async insert(h, e) {
  }
  async delete(h) {
  }
}();
class Ve {
  constructor(e, t) {
    a(this, "loopCount", 1 / 0);
    a(this, "_endFrame", -1);
    a(this, "playedLoopCount", 0);
    a(this, "lastFrameIndex", 0);
    a(this, "onEnd");
    a(this, "onLoopCount");
    const i = typeof e;
    i === "boolean" ? this.loopCount = e ? 1 / 0 : 1 : i === "number" && (this.loopCount = Number(e)), t !== void 0 && (this._endFrame = t);
  }
  reset() {
    this.playedLoopCount = 0, this.lastFrameIndex = 0;
  }
  setEndFrame(e) {
    d.info("[LoopChecker]setEndFrame value=", e), e !== void 0 && (this._endFrame = e);
  }
  checkFrame(e) {
    return this._endFrame > 10 ? this.lastFrameIndex < this._endFrame && this.lastFrameIndex > this._endFrame / 2 && (e >= this._endFrame || e <= this._endFrame / 2) : (this.lastFrameIndex < this._endFrame || this.lastFrameIndex > 10) && e >= this._endFrame && e < 10;
  }
  updateFrame(e) {
    return this.checkFrame(e) && (d.info("[LoopChecker] this.playedLoopCount=", this.playedLoopCount, ", this.lastFrameIndex=", this.lastFrameIndex, ", frame", e, ", endFrame=", this._endFrame, ", this.loopCount=", this.loopCount), this.playedLoopCount = this.playedLoopCount + 1, this.onLoopCount && this.onLoopCount({ count: this.playedLoopCount }), this.playedLoopCount === this.loopCount) ? (this.onEnd && this.onEnd(), !1) : (this.lastFrameIndex = e, !0);
  }
}
class He {
  constructor(e) {
    a(this, "video");
    a(this, "eventsFn", {});
    a(this, "animator");
    a(this, "blobUrl");
    a(this, "polyfillCreateObjectURL");
    a(this, "timeoutId", null);
    a(this, "loopChecker");
    a(this, "videoFile");
    a(this, "isSupportHevc", !1);
    a(this, "startFlag", !1);
    a(this, "pollyfillTipsElement");
    a(this, "onStart");
    a(this, "onResume");
    a(this, "onPause");
    a(this, "onStop");
    a(this, "onProcess");
    a(this, "onEnd");
    a(this, "onError");
    a(this, "onLoadedmetadata");
    a(this, "isPlay", !1);
    a(this, "renderer");
    a(this, "renderType");
    a(this, "animationType");
    a(this, "op");
    a(this, "fps", 0);
    a(this, "version");
    a(this, "webglVersion");
    a(this, "setPlay", (e) => {
      this.renderer && (this.renderer.isPlay = e, this.animator.isPlay = e, this.isPlay = e);
    });
    a(this, "videoEvent", (e) => {
      d.debug(`[${e.type}]:`), this.eventsFn[e.type] && this.eventsFn[e.type]();
    });
    a(this, "videoVisbility", () => {
      d.debug("[visibilitychange]", document.hidden, "this.isPlay=", this.isPlay), document.hidden ? (d.debug("[visibilitychange] pause"), this.video.pause()) : (d.debug("[visibilitychange] play"), this.isPlay && this._playVideo());
    });
    if (!e.container)
      throw new Error("container is need!");
    if (!e.videoUrl)
      throw new Error("videoUrl is need!");
    this.op = e, this.loopChecker = new Ve(this.op.loop, this.op.endFrame), this.loopChecker.onLoopCount = this.op.onLoopCount, this.video = this.videoCreate(), this.animator = new Se(this.video, this.op), this.polyfillCreateObjectURL = (T.baidu || T.quark || T.uc) && this.op.forceBlob === !1, this.op.renderType === "canvas2d" ? (this.renderer = new ie(this.op), this.renderType = "canvas2d") : (this.renderer = new Ie(this.op), this.renderType = "webgl"), this.webglVersion = this.renderer.webgl.version, this.webglVersion === "canvas2d" && this.renderType == "webgl" && (this.op.renderType = "canvas2d", d.debug("[player] webgl to canvas2d"), this.renderer.destroy(), this.renderer = new ie(this.op), this.renderType = "canvas2d"), K.IndexDB = this.op.useVideoDBCache, this.loopChecker.onEnd = () => {
      d.debug("[player] onEnd...url:", this.op.videoUrl), this._onEnd();
    };
  }
  _onEnd() {
    this.stop();
    const e = this.onEnd;
    this.op.endPause || this.destroy(), e && e();
  }
  _error(e) {
    d.error("[EVdeo] error err:", e);
    const t = this.onEnd, i = this.onError;
    this.stop(), this.destroy(), t && (t == null || t(e)), i && (i == null || i(e));
  }
  async setup() {
    var e, t;
    try {
      if (d.debug("[=== e-video setup ===]"), await this.videoLoad(), await this.renderer.setup(this.video), this.renderer.videoEntity.hasAudio ? this.video.muted = this.op.mute !== void 0 && this.op.mute : this.video.muted = !0, this.fps = this.renderer.videoEntity.fps, d.debug("[EVdeo] this.renderer.videoEntity.fps", this.renderer.videoEntity.fps), this.animator.setVideoFps({ fps: this.renderer.videoEntity.fps, videoFps: this.renderer.videoEntity.videoFps }), this._updateEndFrame(), await this.animator.setup(), this.animator.onUpdate = (i) => {
        if (this.loopChecker.updateFrame(i))
          try {
            this.renderer.render(i);
          } catch (s) {
            d.error("[EVdeo] render frame error"), this._error(s);
          }
      }, this.animationType = this.animator.animationType, this.renderer.renderCache.mCache.setOptions({ fps: this.fps, animationType: this.animationType, videoDurationTime: this.video.duration }), d.debug("[setup]", this.animationType, this.webglVersion), this.webglVersion !== "canvas2d" && this.op.renderType !== "canvas2d") {
        const i = this.renderer, s = !!this.op.useFrameCache && i.renderCache.isCache();
        if (this.animationType !== "requestVideoFrameCallback" && !this.op.showVideo && !s) {
          const o = this.video;
          o.style.position = "fixed", o.style.opacity = "0.1", o.style.left = "0", o.style.top = "0", o.style.visibility = "visible", o.style.width = "2px", o.style.height = "2px", o.style.pointerEvents = "none", o.style.userSelect = "none";
        }
      }
    } catch (i) {
      (e = this.onEnd) == null || e.call(this, i), (t = this.onError) == null || t.call(this, i), this.destroy(), d.error(i);
    }
  }
  _updateEndFrame() {
    let e = this.op.endFrame;
    const t = this.video.duration, i = Math.max(0, Math.floor(this.fps * t) - 5);
    this.op.endPause && (e === void 0 || e < 0) && (e = i), e = Math.min(i, e || 0), d.debug("[player]_updateEndFrame, endFrame=", e, ", op.endFrame=", this.op.endFrame), this.loopChecker.setEndFrame(e);
  }
  isDestroyed() {
    d.debug("player is destroyed!");
  }
  start() {
    if (d.debug("player start!, url=", this.op.videoUrl), !this.renderer)
      return this.isDestroyed();
    this.startFlag = !0, this.startEvent();
  }
  cleanTimer() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  beginTimer() {
    d.debug("[player]beginTimer..., duration=", this.video.duration, "loop=", this.loop(), "checkTimeout=", this.op.checkTimeout), this.loopChecker.loopCount === 1 && this.op.checkTimeout && this.video.duration > 0 && (this.cleanTimer(), this.timeoutId = setTimeout(() => {
      d.debug("[player] timeout...url:", this.op.videoUrl), this._onEnd();
    }, 1e3 * this.video.duration + 100));
  }
  clickToPlay() {
    this.op.onRequestClickPlay ? this.pollyfillTipsElement = this.op.onRequestClickPlay(this.op.container, this.video) : this.pollyfillTipsElement = ((e, t) => {
      const i = document.createElement("div");
      return i.innerText = "Click To Play", i.style.textAlign = "center", i.style.background = "rgba(255,255,255,0.7)", i.style.position = "absolute", i.style.zIndex = "99999", i.style.top = "50%", i.style.left = "50%", i.style.padding = "10px", i.style.transform = "translate(-50%,-50%)", i.style.cursor = "pointer", i.style["border-radius"] = "5px", e.appendChild(i), i.onclick = () => {
        t.play(), i.style.display = "none";
      }, i;
    })(this.op.container, this.video);
  }
  hidePollyfileTips() {
    this.pollyfillTipsElement && this.pollyfillTipsElement && (this.pollyfillTipsElement.style.display = "none");
  }
  startEvent() {
    var t, i;
    if (!this.startFlag && !this.op.autoplay)
      return void d.info("startEvent() this.startFlag is false");
    if (!this.renderer || this.renderer.isPlay === !0)
      return;
    if (this.setPlay(!0), this.animator.start(), this.beginTimer(), this.loopChecker.reset(), this.video.currentTime = 0, document.hidden)
      return void d.info("startEvent() document.hidden..");
    const e = this.video.play();
    e ? e.then(() => {
      d.debug(this.op.mute === !1 ? "声音播放" : "静音播放");
    }).catch((s) => {
      var o, r;
      if (T.safari && T.mac)
        return d.debug("切换到静音播放", this.op.videoSource), this.video.muted = !0, void this.video.play().catch((n) => {
          var c, l;
          d.debug(n), (l = (c = this.op) == null ? void 0 : c.onError) == null || l.call(c, n);
        });
      d.error("play error: ", this.op.videoSource, s, "e?.code=", s == null ? void 0 : s.code, ", e?.name=", s == null ? void 0 : s.name, ", url=", this.op.videoUrl), (s == null ? void 0 : s.code) !== 20 && (this.clickToPlay(), (s == null ? void 0 : s.code) === 0 && (s == null ? void 0 : s.name) === L.NotAllowedError && ((r = (o = this.op) == null ? void 0 : o.onError) == null || r.call(o, { playError: L.NotAllowedError, video: this.video, playStep: Z.muted })));
    }) : (i = (t = this.op) == null ? void 0 : t.onEnd) == null || i.call(t);
  }
  stop() {
    if (d.debug("[player]stop."), !this.renderer)
      return this.isDestroyed();
    this.renderer.isPlay !== !1 && (this.setPlay(!1), this.animator.stop(), this.video.pause(), this.cleanTimer());
  }
  loop() {
    return !!this.op.endPause || this.loopChecker.loopCount > 1;
  }
  _playVideo() {
    if (!this.startFlag && !this.op.autoplay)
      return this.video.pause(), void d.info("_playVideo() this.startFlag is false");
    const e = this.video.play();
    e && e.catch((t) => {
      var i, s;
      d.warn("_playVideo() error canplaythrough to play", t.code, t.message, t.name), (t == null ? void 0 : t.code) === 0 && (t == null ? void 0 : t.name) === L.NotAllowedError && ((s = (i = this.op) == null ? void 0 : i.onError) == null || s.call(i, { playError: L.NotAllowedError, video: this.video, playStep: Z.canplaythrough }));
    });
  }
  _updateVideoSource(e) {
    const t = this.op;
    e instanceof File ? (t.useVideoDBCache = !1, this.videoFile = e, this.op.videoSource = e.name) : this.op.videoSource = e;
  }
  videoCreate() {
    const e = this.op;
    if (this._updateVideoSource(e.videoUrl), T.quark && T.android) {
      const o = this.op.videoSource.indexOf("?") > -1 ? "&" : "?";
      this.op.videoSource = `${this.op.videoSource}${o}_quark_${Math.round(1e5 * Math.random())}`, this.op.useFrameCache = !1, this.op.useVideoDBCache = !1;
    }
    const t = this.op.videoID || this.op.videoSource;
    d.debug("[videoID]", t);
    const i = t ? document.getElementById(t) : void 0;
    let s;
    return i instanceof HTMLVideoElement ? s = i : (s = document.createElement("video"), s.setAttribute("id", t), document.body.appendChild(s)), this.isSupportHevc = ((o) => !(!o.canPlayType('video/mp4; codecs="hev1.1.6.L93.B0"') && !o.canPlayType('video/mp4; codecs="hev1.2.4.L120.B0"')))(s), this.isSupportHevc && e.hevcUrl && (this._updateVideoSource(e.hevcUrl), e.videoUrl = e.hevcUrl, this.op.isHevc = !0), this.op.showVideo || (s.style.position = "fixed", s.style.opacity = "0", s.style.left = "-9999px", s.style.top = "9999px", s.style.visibility = "hidden"), s.loop = this.loop(), s.crossOrigin = "anonymous", s.autoplay = this.op.autoplay, s.preload = "auto", s.setAttribute("preload", "auto"), s.setAttribute("x5-playsinline", "true"), s.setAttribute("playsinline", "true"), s.setAttribute("webkit-playsinline", "true"), s.setAttribute("x-webkit-airplay", "allow"), s.setAttribute("t7-video-player-type", "h5"), s.setAttribute("x5-video-player-type", "h5"), (T.quark || T.uc) && s.setAttribute("renderer", "standard"), s;
  }
  async videoAddEvents() {
    const e = this.video;
    return this.eventsFn.canplaythrough = () => {
      d.log("[canplaythrough paused] ", e.paused), e.paused && (d.log("[canplaythrough] isPlay=", this.isPlay), this.isPlay ? this._playVideo() : d.log("[canplaythrough] isPlay is false!"));
    }, this.eventsFn.stalled = () => {
      this.video.load();
    }, this.eventsFn.playing = () => {
      d.log("[player]on playing."), this.startEvent(), this.onStart && this.onStart(), this.hidePollyfileTips();
    }, this.eventsFn.pause = () => {
      d.log("[player]on pause."), this.onPause && this.onPause();
    }, this.eventsFn.resume = () => {
      this.startEvent(), this.onResume && this.onResume();
    }, this.eventsFn.ended = () => {
      const t = this.onEnd;
      this.op.onLoopCount && this.op.onLoopCount({ count: 1 }), this.destroy(), t && t();
    }, this.eventsFn.progress = () => {
      this.onProcess && this.onProcess();
    }, this.eventsFn.stop = () => {
      this.onStop && this.onStop();
    }, this.eventsFn.seeked = () => {
      this.renderer.videoSeekedEvent();
    }, this.eventsFn.error = (t) => {
      this.onError && this.onError(t);
    }, se.map((t) => {
      e.addEventListener(t, this.videoEvent, !1);
    }), document.addEventListener("visibilitychange", this.videoVisbility, !1), new Promise((t) => {
      this.onLoadedmetadata && e.removeEventListener("loadedmetadata", this.onLoadedmetadata), this.onLoadedmetadata = (i) => {
        this.videoEvent(i), t(i), d.debug("[video loadedmetadata]", e.videoWidth, e.videoHeight, e.src.length);
      }, e.addEventListener("loadedmetadata", this.onLoadedmetadata);
    });
  }
  async videoLoad() {
    const e = this.video;
    if (this.op.usePrefetch) {
      const t = await this.prefetch();
      e.src = t, d.debug("[prefetch url]", t);
    } else {
      if (e.src = this.op.videoSource, this.op.useMetaData) {
        const t = await this.getVideoFile();
        await this.readFileToBlobUrl(t);
      }
      d.debug("[videoSource url]", this.op.videoSource);
    }
    e.load(), d.debug("[video load]"), await this.videoAddEvents();
  }
  removeVideoEvent() {
    se.map((e) => {
      this.video.removeEventListener(e, this.videoEvent, !1);
    }), document.removeEventListener("visibilitychange", this.videoVisbility, !1), this.video && (this.video.removeEventListener("loadedmetadata", this.onLoadedmetadata, !1), this.video.pause(), this.op.videoID || (this.video.removeAttribute("src"), this.video.load(), this.video.remove()));
  }
  revokeObjectURL(e) {
    this.blobUrl && (URL.revokeObjectURL(this.blobUrl), d.debug(`[${e} revokeObjectURL]`, this.blobUrl.length), this.blobUrl = void 0);
  }
  createObjectURL(e) {
    return d.debug("[createObjectURL]"), URL.createObjectURL(e);
  }
  destroy() {
    if (!this.renderer)
      return this.isDestroyed();
    this.revokeObjectURL("destroy"), d.debug("[destroy]"), this.setPlay(!1), this.removeVideoEvent(), this.renderer.destroy(), this.animator.destroy(), this.renderer = void 0, this.animator = void 0, this.version = void 0, this.videoFile = void 0, this.videoVisbility = void 0, this.onLoadedmetadata = void 0, this.onStart = void 0, this.onResume = void 0, this.onPause = void 0, this.onStop = void 0, this.onProcess = void 0, this.onEnd = void 0, this.onError = void 0, this.cleanTimer(), this.videoEvent = void 0, this.eventsFn = {};
  }
  async checkVideoCache() {
    try {
      const e = await K.model().find(this.op.videoSource);
      if (e) {
        const { blob: t, data: i } = e;
        return i && this.renderer.videoEntity.setConfig(i), d.debug("[checkVideoCache]"), this.blobUrl = this.createObjectURL(t), this.blobUrl;
      }
    } catch (e) {
      d.error(e);
    }
  }
  async getVideoFile() {
    let e;
    return e = this.videoFile ? this.videoFile : await function(t) {
      return new Promise(async (i, s) => {
        i(await fetch(t).then((o) => o.ok ? o.blob() : void d.error("fetch request failed, url: " + this.op.videoSource)).catch((o) => {
          d.error("getVideoByHttp fetch, err=", o);
        }));
      });
    }(this.op.videoSource), e;
  }
  async prefetch() {
    if (this.op.useVideoDBCache && !this.polyfillCreateObjectURL) {
      const i = await this.checkVideoCache();
      if (i)
        return i;
    }
    const e = await this.getVideoFile(), t = await this.readFileToBlobUrl(e);
    return d.debug("[prefetch result]", t, "this.op.useVideoDBCache", this.op.useVideoDBCache), t;
  }
  readFileToBlobUrl(e) {
    return new Promise((t, i) => {
      const s = new FileReader();
      s.readAsDataURL(e), s.onloadend = () => {
        let o = s.result, r = atob(o.slice(o.indexOf(",") + 1)), n;
        if (new RegExp("H.265/HEVC").test(r) && (this.op.isHevc = !0), this.op.useMetaData && (n = Ne.getdata(r), n && this.renderer.videoEntity.setConfig(n)), this.polyfillCreateObjectURL)
          t(this.op.videoSource);
        else {
          const c = Array(r.length);
          for (let p = 0; p < r.length; p++)
            c[p] = r.charCodeAt(p);
          const l = new Uint8Array(c), u = new Blob([l], { type: "video/mp4" });
          this.op.useVideoDBCache && K.model().insert(this.op.videoSource, { blob: u, data: n }), this.blobUrl = this.createObjectURL(u), t(this.blobUrl);
        }
        o = void 0, r = void 0;
      };
    });
  }
}
async function We(h) {
  const e = { showVideo: !1, useWorker: !1, loop: !0, autoplay: !0, videoUrl: "", videoID: null, dataUrl: "", offset: 0, usePrefetch: !0, useBitmap: !0, useAccurate: !1, useMetaData: !1, alphaDirection: "left", useVideoDBCache: !0, useFrameCache: !1, useOfsRender: !1, resizeCanvas: "percent", showPlayerInfo: !0, forceBlob: !1, checkTimeout: !1, endPause: !1, font: { overflow: "cut" }, ...h };
  e.useMetaData && e.usePrefetch && (e.usePrefetch = !0), e.useFrameCache && (e.useOfsRender = !0), self.createImageBitmap || (e.useBitmap = !1), B() && e.useOfsRender || (e.useOfsRender = !1, e.useFrameCache = !1), self.indexedDB || (e.useVideoDBCache = !1), T.android && T.baidu && (e.useAccurate = !1), d.setup({ level: e.logLevel, showtips: !!e.showPlayerInfo }), T.weixin && T.ios && await Fe.wxReady();
  const t = new He(e);
  return e.onStart && (t.onStart = e.onStart), e.onStop && (t.onStop = e.onStop), e.onEnd && (t.onEnd = e.onEnd), e.onPause && (t.onPause = e.onPause), e.onResume && (t.onResume = e.onResume), e.onProcess && (t.onProcess = e.onProcess), e.onError && (t.onError = e.onError), await t.setup(), e.showPlayerInfo && ((i, s) => {
    if (i.showPlayerInfo === "table")
      return console.table({ Version: Y, RenderType: i.renderType === "canvas2d" ? i.renderType : `WebGL.${s.webglVersion}`, FPS: s.fps, DisplayMode: i.mode, LoadType: i.usePrefetch ? " MSE" : "src", OffScreenRender: !!i.useOfsRender, UseFrameCache: !!i.useFrameCache, UseVideoDBCache: !!i.useVideoDBCache, AnimationType: s.animationType });
    console.log(`%c ${re} ${Y} %c ${i.renderType === "canvas2d" ? i.renderType : `WebGL.${s.webglVersion}`}${self.devicePixelRatio ? ` DPR.${self.devicePixelRatio}` : ""} FPS.${s.fps}${i.mode ? ` ${i.mode}` : ""}${i.isHevc ? " H265" : " H264"}${i.usePrefetch ? " MSE" : ""}${i.useOfsRender ? " OfsRender" : ""}${i.useFrameCache ? " FrameCache" : ""}${i.useVideoDBCache ? " VideoCache" : ""} ${s.animationType} %c`, "background:#34495e ; padding: 1px; border-radius: 2px 0 0 2px;  color: #fff", "background:#16a085 ; padding: 1px; border-radius: 0 2px 2px 0;  color: #fff", "background:transparent");
  })(e, t), t;
}
const qe = Y, je = ve;
export {
  We as default,
  je as mode,
  qe as version,
  Fe as wechatPolyfill,
  We as yyEva
};
//# sourceMappingURL=yyeva.js.map
